export const normalizeEgyptMobile = (value = "") => {
  const digits = value.replace(/\D/g, "");
  return digits.startsWith("20") ? digits.slice(2) : digits;
};

export function formatBirthDateForApi(dateStr) {
  if (!dateStr || typeof dateStr !== "string") {
    return null;
  }

  try {
    const dateParts = dateStr.split("-");
    if (dateParts.length === 3) {
      const year = parseInt(dateParts[0], 10);
      const month = parseInt(dateParts[1], 10);
      const day = parseInt(dateParts[2], 10);

      if (
        year >= 1900 &&
        year <= new Date().getFullYear() &&
        month >= 1 &&
        month <= 12 &&
        day >= 1 &&
        day <= 31
      ) {
        return dateStr;
      }
    }
    console.error("Invalid date format:", dateStr);
    return null;
  } catch (error) {
    console.error("Date processing error:", error);
    return null;
  }
}

export function sortCountries(list, dir) {
  if (!Array.isArray(list)) return [];
  return [...list].sort((a, b) => {
    if (dir === "rtl") {
      return a.name < b.name ? -1 : 1;
    }
    if (a.translations?.length > 0 || b.translations?.length > 0) {
      return a.translations[0]?.name < b.translations[0]?.name ? -1 : 1;
    }
    return a.name < b.name ? -1 : 1;
  });
}

export function buildRegisterPayload(data, selectedPhoneCountry) {
  const normalizedMobile = String(data.mobile || "").replace(/\D/g, "");
  const localEgyptMobile = normalizedMobile.startsWith("20")
    ? normalizedMobile.slice(2)
    : normalizeEgyptMobile(normalizedMobile);

  return {
    normalizedMobile,
    localEgyptMobile,
    loginData: {
      firstName: data.firstName,
      lastName: data.lastName,
      username: data.username,
      phoneNumber:
        selectedPhoneCountry === "eg" ? localEgyptMobile : normalizedMobile,
      gender: data.gender,
      email: data.email,
      password: data.password,
      confirmPassword: data.reenterPassword,
      address: data.address,
      job: data.job,
      birthDate: data.dob ? formatBirthDateForApi(data.dob) : null,
      degree: data.degree,
      subscriptionTypeId: data.registrationType,
      countryId: data.country,
    },
  };
}
